import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/store';
import { UsersListState, USERS_LIST_SLICE_NAME } from './models';

export const usersSelector = (state: RootState): UsersListState => state[USERS_LIST_SLICE_NAME];

export const selectUsersIsLoading = createSelector(usersSelector, (state: UsersListState) => state.isLoading);

export const selectUsersList = createSelector(usersSelector, (state: UsersListState) => state.usersList);

export const selectUserFilters = createSelector(usersSelector, (state: UsersListState) => state.userFilters);
